import { render } from "./Calculate.vue?vue&type=template&id=1ebe598a"
import script from "./Calculate.vue?vue&type=script&lang=ts"
export * from "./Calculate.vue?vue&type=script&lang=ts"
script.render = render

export default script